<template>
  <div>
    <el-dialog :title="title" :visible.sync="addPlanBillVisible" :close-on-click-modal="false" :before-close="addCancel" center width="95%">
      <el-form :inline="true" label-width="90px" ref="addBillForm" class="demo-form-inline" :model="addBillForm" :rules="rules">
        <el-form-item label="一级货主:" prop="primaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.primaryCustomerTaxId" :disabled='disprimaryCustomerTaxId' filterable placeholder="请选择" style="width:170px" size="mini" @change="primaryCustomerTaxIdChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:" prop="secondaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.secondaryCustomerTaxId" :disabled='dissecondaryCustomerTaxId' filterable placeholder="请选择" style="width:170px" size="mini" @change="secondaryCustomerChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户单号:" prop="outBillNo">
          <el-input v-model="addBillForm.outBillNo" maxlength="35" placeholder="请输入客户单号" style="width:170px" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="提货客户:">
          <el-input v-model="addBillForm.pickupCustomerName" maxlength="50" placeholder="请输入提货客户" style="width:170px" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="addBillForm.remark" maxlength="100" :rows="1" style="width:300px;">
          </el-input>
        </el-form-item>
        <el-form-item label="收货单位:" prop="queueReceivUnit">
          <el-select clearable v-model="queueReceivUnit" filterable placeholder="请选择" style="width:170px" size="mini">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.custerName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <p>人车信息
          <!-- <el-button type="primary" @click="addSiji" >新增</el-button>  -->
        </p>
        <hr>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="subTableData" style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column :show-overflow-tooltip="true" type="index" prop="date" width="55" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="plateNumber" label="提货车号">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disPlateNum' v-model="scope.row.plateNumber" placeholder="请输入提货车号" @blur="vhcInput(scope.row.plateNumber)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disDriverName' v-model="scope.row.driverName" placeholder="请输入司机姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disIdNum' v-model="scope.row.idNumber" placeholder="请输入司机身份证号" @blur="idInput(scope.row.idNumber)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disTelephone' v-model="scope.row.telephone" placeholder="请输入司机联系电话" @blur="phoneInput(scope.row.telephone)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" :disabled='scope.row.disSelectSiji' @click="selectSiji(scope.row,scope.$index)">
                选择司机</el-button>
              <!-- <el-button type="text" :disabled='scope.row.disDeleteTable' @click="deleteTable(scope.row,scope.$index)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <p>货物信息
          <!-- <el-button type="primary" @click="addHuoWu" v-if="addBtnShow">新增</el-button> -->
        </p>
        <hr>
        <el-table size="mini" :data="detailsDataCopyAdd" ref="demoTable" style="width:100%;margin-top:20px;" :header-cell-style="{background:'#f5f5f5'}" empty-text="">
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width="130">
            <template slot-scope="scope1">
              <el-select clearable filterable v-model="scope1.row.placeOfOrigin" @change="changeChanDi(scope1.row,scope1.row.placeOfOrigin)" size="mini" placeholder="请选择产地" :disabled="scope1.row.disChandi">
                <el-option v-for="(item,index) in chanDiOptions" :key="index" :label="item.steelMillName" :value="item.steelMillName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="productType" align="center" label="货物类型" width="130">
            <template slot-scope="scope1">
              <el-select v-model="scope1.row.productType" size="mini" clearable placeholder="请选择货物类型" @change="selectProductType(scope1.row,scope1.row.productType)" :disabled="scope1.row.disProductType">
                <el-option v-for="(item,index) in scope1.row.productTypeOptions" :key="index" :label="item.productTypeName" :value="item.productType"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width="130">
            <template slot-scope="scope1">
              <el-select clearable filterable @change="changeGuiGe(scope1.row,scope1.row.specification)" v-model="scope1.row.specification" size="mini" :disabled="scope1.row.disGuige" placeholder="请选择规格">
                <el-option v-for="(item,index) in scope1.row.guigeOptions" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="model" align="center" label="材质" width="150">
            <template slot-scope="scope1">
              <el-select clearable filterable @change="changeCaiZhi(scope1.row,scope1.row.model)" v-model="scope1.row.model" size="mini" :disabled="scope1.row.disCaizhi" placeholder="请选择材质">
                <el-option v-for="(item,index) in scope1.row.caizhiOptions" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseId" align="center" label="仓位" width="140">
            <template slot-scope="scope1">
              <el-select clearable filterable @change="changeCangWei(scope1.row,scope1.row.warehouseId)" v-model="scope1.row.warehouseId" size="mini" :disabled="scope1.row.disCangWei" placeholder="请选择仓位">
                <el-option v-for="(item,index) in scope1.row.warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="110">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.number" @input="changeJianShu(scope1.row,scope1.row.number)" v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="allWeight" align="center" width="130" label="重量（吨）">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.allWeight" maxlength="50" placeholder="请输入重量" size="mini" :disabled='scope1.row.disWeight' @blur="weightInput(scope1.row,scope1.row.allWeight)">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stockAvailableNumber" align="center" label="客户库存可提件数">
            <template slot-scope="scope1">
              <el-input :disabled="true" v-model="scope1.row.stockAvailableNumber" maxlength="50" placeholder="请输入库存件数" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stockWarehouseNumber" align="center" label="仓位可提件数">
            <template slot-scope="scope1">
              <el-input :disabled="true" v-model="scope1.row.stockWarehouseNumber" maxlength="50" placeholder="请输入仓位可提件数" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop align="center" label="编辑" width="140">
            <template slot-scope="scope2">
              <el-button @click="clearClick(scope2.$index, scope2.row)" type="text" size="small">清空</el-button>
              <el-button @click="baoCunClick(scope2.$index, scope2.row)" type="text" size="small">保存</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div style="color:red;margin-top:8px;">注：默认重量（吨）= 单件理重（吨）* 件数</div> -->
      </div>
      <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
        <!-- <p>货物信息</p>
          <hr> -->
        <div>
          <div style="display: flex;justify-content: space-between;">
            <div style="display: flex;margin-bottom:10px;">
              <div>{{(item.cargoControlKey).replace(/,/g,"")}}</div>
              <div style="display: flex;">
                <span style="margin-left:20px;">总重量：</span>
                <div>
                  <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span>
                  <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
                </div>
              </div>
              <div style="display: flex;" v-if="item.surplus">
                <span style="margin-left:20px;">货权剩余：</span>
                <div>
                  <span v-if='item.controlWeight == 1'><span style="color:red">{{item.surplusControlWeight}}</span><span> 吨</span></span>
                  <span v-if='item.controlPiece == 1'><span> / </span><span style="color:red">{{item.surplusControlNumber}}</span><span> 件</span></span>
                </div>
              </div>
            </div>
            <div style="margin-right:20px;">
              <el-button type="primary" size="mini" @click="delClick(item,ix)">删除</el-button>
            </div>
          </div>
        </div>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list" style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
          <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
          <el-table-column prop="model" align="center" label="材质" width=""></el-table-column>
          <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
          <el-table-column prop="number" align="center" label="件数" width=""></el-table-column>
          <el-table-column prop="allWeight" align="center" label="总重量（吨）" width=""></el-table-column>
          <el-table-column prop="number" align="center" label="操作" width="">
            <template slot-scope="scope1">
              <el-button @click="tabDelClick(item,scope1.$index,ix)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="" @click="addCancel">取消</el-button>
        <el-button type="primary" @click="addSubmit(1)" :loading='addLoading'>保存</el-button>
        <el-button type="primary" :loading="saveLoading" @click="addSubmit(2)" v-if="isShowDYFlag != 2">保存并打印</el-button>

      </div>
    </el-dialog>
    <select-siji v-if="selectSijiVisible" :table.sync="selectSijiVisible" @selectDriver="selectDriver"></select-siji>
  </div>
</template>

<script>
import {
  getRelationCustomer, // 字典客户
  JfgetTEmptyStockCustomerGroup, // 货物类型、产地、材质等下拉框
  JfgetCustomerAvailableNumber, // 获取客户库存可转件数
  getWeighingMethodList, // 判断计重方式
  JfgetEmptyBillStockWarehouseInfo, // 添加计划货物信息 仓位下拉框 & 客户库存Id
  JfgetNumberForBillStockWarehouse, // 添加货物信息 仓位选择后 取得仓位可提件数
  JfvirtualControlBean, // 调用控货接口
  JfaddEmptyOutstockJanFa, // 添加出库计划确定
  JfgetOutstockInfoJanFa // 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
} from '@/api/wms-stock.js'
import SelectSiji from '@/views/jianfa/jfChuKuGuanLi/SelectSiji'
import { schedulingUpdateWarehouse } from '@/api/lj'
const vhsrule =
  /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
const phonerule = /^[1]([3-9])[0-9]{9}$/

export default {
  components: {
    SelectSiji
  },
  name: 'XinzengTidan',
  data () {
    return {
      addBillForm: {
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        ownerCustomerTaxId: '',
        ownerCustomerName: '',
        outBillNo: '',
        carHoldFalg: '',
        remark: '',
        billId: '', // 出库提单id
        outstockId: '' // 出库单id
      },
      queueReceivUnit: '',
      customerData: [], // 货主数据
      rules: {
        primaryCustomerTaxId: [{
          required: true,
          message: '请选择一级货主',
          trigger: 'change'
        }],
        secondaryCustomerTaxId: [{
          required: true,
          message: '请选择二级货主',
          trigger: 'change'
        }]
      },
      subTableData: [],
      subTableDataB: [],
      addLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      hasValidFlag: true,
      detailsDataCopyAdd: [], // 添加货物数据
      productTypeOptions: [], // 货物类型
      chanDiOptions: [], // 产地
      caizhiOptions: [], // 材质
      guigeOptions: [], // 规格
      disprimaryCustomerTaxId: false,
      dissecondaryCustomerTaxId: false,
      emptyBillType: '',
      billNo: '',
      addBtnShow: false,
      allDataList: [],
      searchArr: [],
      parentData: {},
      jianShuArr: [],
      xuanzhongArr: null,
      saveLoading: false,
      paramsObject: {}
    }
  },
  props: {
    title: {
      type: String,
      default: '新增出库计划'
    },
    addPlanBillVisible: {
      type: Boolean,
      default: false
    },
    xztableData: {
      type: Array
    },
    xiugaiObj: {
      type: Object
    },
    isShowDYFlag: {
      type: Number
    },
    mobilePhone: {
      type: String
    },
    vhcNo: {
      type: String
    },
    ljjcId: {
      type: Number
    },
    rowData: {
      type: Object
    }
  },
  watch: {
    rowData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && val.receiveCompanyName && this.customerData.length > 0) {
          this.matchReceiveCompanyName()
        }
      }
    },
    xztableData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length == 0) { } else { }
      }
    },
    xiugaiObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          // console.log(val, '修改数据')
          // this.addBillForm.outBillNo = val.outBillNo
          // this.addBillForm.primaryCustomerTaxId = val.primaryCustomerTaxId
          // this.addBillForm.secondaryCustomerTaxId = val.customerTaxId
          // this.addBillForm.remark = val.remark
          // this.addBillForm.billId = val.billId
          // this.addBillForm.outstockId = val.outstockId
          // this.emptyBillType = val.emptyBillType
          // this.billNo = val.billNo
          // if (this.emptyBillType == '0') {
          //   this.addBtnShow = true
          // } else {
          //   this.addBtnShow = false
          // }
        }
      }
    }
  },
  created () {
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.addDialogPrint()
      }
    }
  },
  mounted () {
    this.getRelationCustomer()
    this.addSiji()
    this.addHuoWu()
    this.changeGetOptions()
    if (this.mobilePhone) {
      this.subTableData[0].telephone = this.mobilePhone
    }
    if (this.vhcNo) {
      this.subTableData[0].plateNumber = this.vhcNo
    }
    if (this.rowData.driverName) {
      this.subTableData[0].driverName = this.rowData.driverName
    }
    if (this.isShowDYFlag == 2) {
      this.detailsDataCopyAdd.forEach(item => {
        this.$set(item, 'queueId', this.ljjcId)
      })
    }
    this.detailsDataCopyAdd[0].number = 1
    this.detailsDataCopyAdd[0].allWeight = 1
    this.detailsDataCopyAdd[0].weight = 1
    // 如果 customerData 已经存在，直接匹配
    if (this.customerData.length > 0 && this.rowData && this.rowData.receiveCompanyName) {
      this.matchReceiveCompanyName()
    }
  },
  methods: {
    // 根据 receiveCompanyName 匹配收货单位
    matchReceiveCompanyName () {
      if (!this.rowData || !this.rowData.receiveCompanyName || this.customerData.length === 0) {
        return
      }

      const receiveCompanyName = this.rowData.receiveCompanyName.trim()

      // 在 customerData 中查找匹配的客户
      const matchedCustomer = this.customerData.find(
        customer => customer.custerName === receiveCompanyName
      )

      if (matchedCustomer) {
        // 如果找到匹配的客户，设置收货单位为该客户名称
        this.queueReceivUnit = matchedCustomer.custerName
      } else {
        console.warn(`未找到与 receiveCompanyName: ${receiveCompanyName} 匹配的客户`)
      }
    },
    // 根据 deliveryCompanyName 匹配一级和二级货主
    matchCustomerFromDeliveryCompanyName () {
      if (!this.rowData || !this.rowData.deliveryCompanyName || this.customerData.length === 0) {
        return
      }

      const deliveryCompanyName = this.rowData.deliveryCompanyName.trim()

      // 在 customerData 中查找匹配的客户
      const matchedCustomer = this.customerData.find(
        customer => customer.custerName === deliveryCompanyName
      )

      if (matchedCustomer) {
        // 如果找到匹配的客户，设置一级货主和二级货主为该客户
        this.addBillForm.primaryCustomerTaxId = matchedCustomer.taxpayerNumber
        this.addBillForm.secondaryCustomerTaxId = matchedCustomer.taxpayerNumber
        this.changeGetOptions()
        // 如果需要，可以同时设置名称
        // this.addBillForm.primaryCustomerName = matchedCustomer.custerName
        // this.addBillForm.secondaryCustomerName = matchedCustomer.custerName

        // 触发二级货主change事件，以加载相关数据
        this.secondaryCustomerChange()
      } else {
        console.warn(`未找到与 deliveryCompanyName: ${deliveryCompanyName} 匹配的客户`)
      }
    },
    // 乐居进仓登记创建计划之后更新仓位信息
    schedulingUpdateWarehouse () {
      schedulingUpdateWarehouse({
        id: this.ljjcId,
        warehouseId: this.detailsDataCopyAdd[0].warehouseId,
        warehouseName: this.detailsDataCopyAdd[0].warehouseName
      })
        .then((res) => {
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    changeGetOptions () {
      // console.log(this.addBillForm.primaryCustomerTaxId, '匹配方法')
      if (!this.addBillForm.primaryCustomerTaxId || !this.addBillForm.secondaryCustomerTaxId) {
        console.warn('一级货主或二级货主为空，跳过调用接口')
        return
      }
      JfgetTEmptyStockCustomerGroup({
        primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.addBillForm.secondaryCustomerTaxId // （二级货主id 必填）
        // productType: row.productType, // （货物类型id  非必填）
        // steelMillName: '', // （产地  非必填）
        // model: '', // （材质 非必填）
        // specification: '' // （规格  非必填）
      }).then(res => {
        this.chanDiOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    addSiji () {
      let obj = {}
      obj.plateNumber = ''
      obj.driverName = ''
      obj.idNumber = ''
      obj.telephone = ''
      obj.delFlag = ''
      obj.disPlateNum = false
      obj.disDriverName = false
      obj.disIdNum = false
      obj.disTelephone = false
      obj.disSelectSiji = false
      obj.disDeleteTable = false
      this.subTableData.push(obj)
    },
    addHuoWu () {
      let obj = {
        placeOfOrigin: '',
        productType: '',
        productTypeName: '',
        productName: '',
        model: '',
        specification: '',
        warehouseId: '',
        warehouseName: '',
        number: '',
        weight: '',
        stockAvailableNumber: '',
        stockWarehouseNumber: '',
        singletonWeight: 0, // 单件理重
        disProductType: true,
        disChandi: false,
        disGuige: true,
        disCaizhi: true,
        disJianShu: true,
        disWeight: true,
        disCangWei: true,
        chanDiOptions: [],
        productTypeOptions: [],
        guigeOptions: [],
        caizhiOptions: [],
        warehouseOptions: []
      }
      this.detailsDataCopyAdd.push(obj)
    },
    // 清空当前行数据
    clearClick (index, row) {
      this.detailsDataCopyAdd = []
      this.addHuoWu()
    },
    // 点击货物删除-下表格
    delClick (item, ix) {
      this.allDataList.splice(ix, 1)
    },
    tabDelClick (item, ix, index) {
      item.list.forEach((item1, index1) => {
        if (index1 == ix) {
          item.list.splice(ix, 1)
          if (item.list.length == 0) {
            item.num = 0
            item.sumWeight = 0
            this.delClick(item, index)
          } else {
            this.allDataList.forEach(item => {
              this.$set(item, 'num', item.list.reduce((pre, cur) => {
                return pre / 1 + cur.number / 1
              }, 0))
              this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
                return pre / 1 + cur.allWeight / 1
              }, 0)).toFixed(6)))
            })
          }
        }
      })
    },
    addCancel () {
      this.$emit('update:addPlanBillVisible', false)
      this.$parent.xztableData = []
      this.$parent.xiugaiObj = {}
    },

    selectSiji (row, index) {
      this.TableIndex = index
      this.selectSijiVisible = true
    },
    selectDriver (row) {
      console.log(row)
      this.$set(this.subTableData[this.TableIndex], 'driverName', row.name)
      this.$set(this.subTableData[this.TableIndex], 'telephone', row.mobile)
      this.$set(this.subTableData[this.TableIndex], 'idNumber', row.identityNo)
    },
    deleteTable (row, index) {
      this.subTableData.splice(index, 1)
      this.subTableDataB = []
      this.subTableDataB.push(row)
      this.subTableDataB.forEach((item) => {
        row.delFlag = '1'
      })
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
        // 获取客户数据后，根据 rowData.deliveryCompanyName 匹配一级和二级货主
        this.matchCustomerFromDeliveryCompanyName()
        // 获取客户数据后，根据 rowData.receiveCompanyName 匹配收货单位
        this.matchReceiveCompanyName()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    vhcInput (val) {
      // if (!vhsrule.test(val)) {
      //   this.$message({ message: '请输入正确的车牌号', type: 'error' })
      // }
    },
    idInput (val) {
      if (val != '' && !idrule.test(val)) {
        this.$message({
          message: '请输入正确的身份证号',
          type: 'error'
        })
      }
    },
    phoneInput (val) {
      if (val != '' && !phonerule.test(val)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      }
    },
    // 一级货主下拉框改变
    primaryCustomerTaxIdChange () {
      console.log('一级货主')
      this.addBillForm.secondaryCustomerTaxId = ''
      this.detailsDataCopyAdd.forEach((item, index) => {
        console.log(item.productType, 'item.productType')
        if (item.placeOfOrigin != '' || item.productType != '') {
          this.detailsDataCopyAdd = []
          this.addHuoWu()
          this.chanDiOptions = []
        }
      })
    },
    // 二级货主下拉框值改变
    secondaryCustomerChange () {
      if (this.addBillForm.primaryCustomerTaxId == '') {
        this.addBillForm.secondaryCustomerTaxId = ''
        this.$message.error('请先选择一级货主')
      } else {
        JfgetTEmptyStockCustomerGroup({
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
          productType: '', // （货物类型id  非必填）
          steelMillName: '', // （产地  非必填）
          model: '', // （材质 非必填）
          specification: '' // （规格  非必填）
        }).then(res => {
          this.chanDiOptions = res
        }).catch(err => {
          this.$message.error(err.message)
        })
        this.detailsDataCopyAdd.forEach((item, index) => {
          if (item.placeOfOrigin != '' && item.productType != '') {
            this.detailsDataCopyAdd = []
            this.addHuoWu()
          }
        })
      }
    },
    // 产地下拉框值改变
    changeChanDi (row, val) {
      if (this.addBillForm.primaryCustomerTaxId == '' && this.addBillForm.secondaryCustomerTaxId == '') {
        this.$message.error('请先选择一级货主和二级货主')
      } else {
        // 保存当前的件数和重量值
        const currentNumber = row.number
        const currentAllWeight = row.allWeight
        row.disProductType = false
        row.disCaizhi = true
        row.disGuige = true
        row.disJianShu = true
        row.disWeight = true
        row.disCangWei = true
        row.warehouseId = ''
        row.productType = ''
        row.specification = ''
        row.model = ''
        // 保留件数和重量值
        row.number = currentNumber
        row.allWeight = currentAllWeight
        // row.allWeight = ''
        row.factoryWeight = ''
        row.singletonWeight = ''
        row.stockAvailableNumber = ''
        row.stockWarehouseNumber = ''
        row.surplusControlWeight = ''
        row.surplusControlNumber = ''
        JfgetTEmptyStockCustomerGroup({
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
          productType: '', // （货物类型id  非必填）
          steelMillName: row.placeOfOrigin, // （产地  非必填）
          model: '', // （材质 非必填）
          specification: '' // （规格  非必填）
        }).then(res => {
          row.productTypeOptions = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },
    // 货物类型下拉框值改变事件
    selectProductType (row, val) {
      // 保存当前的件数和重量值
      const currentNumber = row.number
      const currentAllWeight = row.allWeight
      row.disGuige = false
      row.disCaizhi = true
      row.disJianShu = true
      row.disCangWei = true
      row.warehouseId = ''
      row.specification = ''
      row.model = ''
      // 保留件数和重量值
      row.number = currentNumber
      row.allWeight = currentAllWeight
      // row.allWeight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.stockAvailableNumber = ''
      row.stockWarehouseNumber = ''
      row.productType = val
      row.productTypeOptions.forEach((item, index) => {
        if (row.productType == item.productType) {
          row.productTypeName = item.productTypeName
          row.productName = item.productTypeName
        }
      })
      // console.log(row.productType, 'productType')
      console.log(row.productTypeName, 'row.productTypeName')
      // this.$set(row, 'productTypeName', row.productTypeOptions.filter(item => item.productType == row.productType)[0].productTypeName)
      JfgetTEmptyStockCustomerGroup({
        primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: row.productType, // （货物类型id  非必填）
        steelMillName: row.placeOfOrigin, // （产地  非必填）
        model: '', // （材质 非必填）
        specification: '' // （规格  非必填）
      }).then(res => {
        row.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
      }).catch(err => {
        this.$message.error(err.message)
      })
      getWeighingMethodList({
        productType: row.productType
      }).then(res => {
        if (res[0].outWeighingMethod == 1) {
          row.disWeight = true
        } else {
          row.disWeight = false
        }
      })
    },
    changeGuiGe (row, val) {
      // 保存当前的件数和重量值
      const currentNumber = row.number
      const currentAllWeight = row.allWeight
      row.disCaizhi = false
      row.disJianShu = true
      row.disCangWei = true
      row.warehouseId = ''
      row.specification = val
      row.model = ''
      // 保留件数和重量值
      row.number = currentNumber
      row.allWeight = currentAllWeight
      // row.allWeight = ''
      // row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.stockAvailableNumber = ''
      row.stockWarehouseNumber = ''
      let obj = {
        primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: row.productType, // （货物类型id  非必填）
        steelMillName: row.placeOfOrigin, // （产地  非必填）
        model: '', // （材质 非必填）
        specification: row.specification // （规格  非必填）
      }
      JfgetTEmptyStockCustomerGroup(obj).then(res => {
        row.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeCaiZhi (row, val) {
      // 保存当前的件数和重量值
      const currentNumber = row.number
      const currentAllWeight = row.allWeight
      row.disCangWei = false
      row.disJianShu = true
      row.warehouseId = ''
      // 保留件数和重量值
      row.number = currentNumber
      row.allWeight = currentAllWeight
      // row.allWeight = ''
      // row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.stockAvailableNumber = ''
      row.stockWarehouseNumber = ''
      row.model = val
      let obj = {
        primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: row.productType, // （货物类型id  非必填）
        steelMillName: row.placeOfOrigin, // （产地  非必填）
        model: val, // （材质 非必填）
        specification: row.specification // （规格  非必填）
      }
      JfgetCustomerAvailableNumber(obj).then(res => {
        row.stockAvailableNumber = res
      }).catch(err => {
        this.$message.error(err.message)
      })
      JfgetEmptyBillStockWarehouseInfo(obj).then(res => {
        row.warehouseOptions = res.tEmptyStockWarehouseList
        this.$set(row, 'stockCustomerId', res.stockCustomerId)
        // console.log(res.stockCustomerId, 'res.stockCustomerId')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeCangWei (row, val) {
      // 保存当前的件数和重量值
      const currentNumber = row.number
      const currentAllWeight = row.allWeight
      row.disJianShu = false
      // row.disJianShu = true
      // 保留件数和重量值
      row.number = currentNumber
      row.allWeight = currentAllWeight
      // row.weight = ''
      // row.allWeight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.stockWarehouseNumber = ''
      row.warehouseOptions.forEach((item, index) => {
        if (val == item.warehouseId) {
          row.singletonWeight = item.singletonWeight
          row.warehouseName = item.warehouseName
          this.$set(row, 'stockWarehouseId', item.stockWarehouseId)
          JfgetNumberForBillStockWarehouse({
            stockWarehouseId: row.stockWarehouseId
          }).then(res => {
            this.$set(row, 'stockWarehouseNumber', res.whAvailableNumber)
            this.$set(row, 'whNumber', res.whNumber)
            this.$set(row, 'whWeight', res.whWeight)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'allWeight', parseFloat((row.number / 1 * row.singletonWeight).toFixed(6)))
        this.$set(row, 'weight', parseFloat((row.number / 1 * row.singletonWeight).toFixed(6)))
      } else {
        this.$set(row, 'allWeight', '0.000')
        this.$message.error('发货件数不能为空')
      }
      // console.log(row, val)
      // console.log(this.allDataList, 'this.allDataList')
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(6)))
      })
    },
    weightInput (val, row) {
      console.log(row, val)
      this.$set(val, 'allWeight', parseFloat(Number(row).toFixed(6)))
    },
    // 当前行保存
    baoCunClick (index, row) {
      this.xuanzhongArr = {}
      if (!row.placeOfOrigin) {
        this.$message.error('请选择产地')
      } else if (!row.productType) {
        this.$message.error('请选择货物类型')
      } else if (!row.specification) {
        this.$message.error('请选择规格')
      } else if (!row.model) {
        this.$message.error('请选择材质')
      } else if (!row.warehouseId) {
        this.$message.error('请选择仓位')
      } else if (!row.number) {
        this.$message.error('请填写件数')
      } else if (!row.allWeight) {
        this.$message.error('请填写重量')
      } else {
        if (row.number > 0) {
          if (row.number > row.stockAvailableNumber) {
            this.$message.error('所输入的件数不能大于客户库存可提件数')
          } else if (row.number > row.stockWarehouseNumber) {
            this.$message.error('所输入的件数不能大于仓位库存可提件数')
          } else {
            this.xuanzhongArr = JSON.parse(JSON.stringify(row))
            this.JfvirtualControlBean()
          }
        } else {
          this.$message.error('所输入件数不能为0')
        }
      }
    },
    // 调用控货接口
    JfvirtualControlBean () {
      JfvirtualControlBean({
        oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
        twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
        organizationId: localStorage.getItem('tenantCode'), // （仓储租户id  必填）
        productionPlaceName: this.xuanzhongArr.placeOfOrigin, // （产地  必填）
        specificationName: this.xuanzhongArr.specification, // （规格  必填）
        materialName: this.xuanzhongArr.model, // （材质  必填）
        goodTypeName: this.xuanzhongArr.productTypeName // （货物类型名称  必填
      }).then(res => {
        console.log(JSON.parse(res), 'res')
        let isEnableObj = JSON.parse(res)
        // controlPiece: 1  // 控件  0不控  1控
        // controlWeight: 1 // 控吨  0不控  1控
        // isEnable: 1    //控货不控货标识   1控  2不控
        if (res) {
          let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
            (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
            (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
            (isEnableObj.materialName ? isEnableObj.materialName : '')
          console.log(str, 'str')
          if (str == ',,,') {
            str = '总控'
          }
          // 控货
          this.$set(this.xuanzhongArr, 'cargoControlKey', str)
          if (isEnableObj.isEnable == '1') {
            this.$set(this.xuanzhongArr, 'surplusControlWeight', isEnableObj.surplusControlWeight)
            this.$set(this.xuanzhongArr, 'surplusControlNumber', isEnableObj.surplusControlNumber)
            this.$set(this.xuanzhongArr, 'controlPiece', isEnableObj.controlPiece)
            this.$set(this.xuanzhongArr, 'controlWeight', isEnableObj.controlWeight)
            if (this.allDataList.some(item => item.cargoControlKey == str)) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
              this.allDataList[index].list.push(this.xuanzhongArr)
              let map = new Map()
              for (let i of this.allDataList[index].list) {
                let str = i.placeOfOrigin + i.productType + i.specification + i.model + i.warehouseId + i.number +
                  i.allWeight
                if (!map.has(str)) {
                  map.set(str, i)
                }
              }
              this.allDataList[index].list = [...map.values()]
              this.allDataList.forEach((item, index) => {
                this.$set(item, 'num', item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.number / 1
                }, 0))
                this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.allWeight / 1
                }, 0)).toFixed(6)))
              })
            } else {
              let obj = {
                cargoControlKey: str,
                releaseFlag: 0,
                list: [],
                surplus: true,
                surplusControlWeight: isEnableObj.surplusControlWeight,
                surplusControlNumber: isEnableObj.surplusControlNumber,
                controlWeight: isEnableObj.controlWeight,
                controlPiece: isEnableObj.controlPiece,
                strictReminder: isEnableObj.strictReminder,
                isEnable: isEnableObj.isEnable
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
              this.allDataList.forEach((item, index) => {
                this.$set(item, 'num', item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.number / 1
                }, 0))
                this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.allWeight / 1
                }, 0)).toFixed(6)))
              })
            }
            console.log(this.allDataList, 'this.allDataList')
          } else {
            // 不控
            this.$set(this.xuanzhongArr, 'cargoControlKey', '不控货')
            if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
              let map = new Map()
              for (let i of this.allDataList[index].list) {
                let str = i.placeOfOrigin + i.productType + i.specification + i.model + i.warehouseId + i.number +
                  i.allWeight
                if (!map.has(str)) {
                  map.set(str, i)
                }
              }
              this.allDataList[index].list = [...map.values()]
              this.allDataList.forEach((item, index) => {
                this.$set(item, 'num', item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.number / 1
                }, 0))
                this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.allWeight / 1
                }, 0)).toFixed(6)))
              })
            } else {
              let obj = {
                cargoControlKey: '不控货',
                list: [],
                surplus: false
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
              this.allDataList.forEach((item, index) => {
                this.$set(item, 'num', item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.number / 1
                }, 0))
                this.$set(item, 'sumWeight', parseFloat((item.list.reduce((pre, cur) => {
                  return pre / 1 + cur.allWeight / 1
                }, 0)).toFixed(6)))
              })
            }
            console.log(this.allDataList, 'this.allDataList')
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    addSubmit (n) {
      // console.log(this.subTableData)
      this.$refs.addBillForm.validate((valid) => {
        if (valid) {
          // let chepai = this.subTableData.some(item => !vhsrule.test(item.plateNumber))
          let idCard = this.subTableData.some(item => !idrule.test(item.idNumber) && item.idNumber != '')
          let phoneCard = this.subTableData.some(item => !phonerule.test(item.telephone) && item.telephone != '')
          // if (chepai) {
          //   this.$message({ message: '车牌号不正确', type: 'error' })
          //   this.addLoading = false
          //   return
          // } else
          if (idCard) {
            this.$message({
              message: '身份证号不正确',
              type: 'error'
            })
            this.addLoading = false
            return
          } else if (phoneCard) {
            this.$message({
              message: '手机号不正确',
              type: 'error'
            })
            this.addLoading = false
            return
          }
          this.addBillForm.primaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
            .addBillForm.primaryCustomerTaxId)[0].custerName
          this.addBillForm.secondaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
            .addBillForm.secondaryCustomerTaxId)[0].custerName
          // console.log(this.addBillForm, this.subTableData)
          let plateNumber = ''
          let driverName = ''
          let telephone = ''
          let idNumber = ''
          plateNumber = this.subTableData.map(item => item.plateNumber).join(',')
          // 司机姓名
          let driverNameArr = this.subTableData.map(item => item.driverName)
          driverNameArr.forEach((item, index) => {
            if (item == '') {
              driverNameArr.splice(index, 1)
            }
          })
          driverName = driverNameArr.join(',')
          // 司机联系电话
          let telephoneArr = this.subTableData.map(item => item.telephone)
          telephoneArr.forEach((item, index) => {
            if (item == '') {
              telephoneArr.splice(index, 1)
            }
          })
          telephone = telephoneArr.join(',')
          // 司机身份证
          let idNumberArr = this.subTableData.map(item => item.idNumber)
          idNumberArr.forEach((item, index) => {
            if (item == '') {
              idNumberArr.splice(index, 1)
            }
          })
          idNumber = idNumberArr.join(',')
          console.log(driverName, telephone, idNumber)
          if (this.title == '新增出库计划') {
            if (this.allDataList.length == 0) {
              this.$message.error('请填写完整信息点击列表保存添加货物信息')
            } else {
              console.log(this.allDataList, 'this.allDataList')
              let flagA = this.allDataList.every(item => item.num == 0 || item.sumWeight == 0)
              console.log(flagA, 'flagA')
              if (flagA) {
                this.$message.error('请完善信息')
                return
              }
              for (let i = 0; i < this.allDataList.length; i++) {
                for (let index = 0; index < this.allDataList[i].list.length; index++) {
                  this.$set(this.allDataList[i].list[index], 'queueReceivUnit', this.queueReceivUnit)
                }
              }
              if (!flagA) {
                this.paramsObject = {
                  tEmptyOutstockMaster: {
                    primaryCustomerName: this.addBillForm.primaryCustomerName, // 一级货主名称 必填
                    primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // 一级货主id 必填
                    customerName: this.addBillForm.secondaryCustomerName, // （二级货主名称 必填）
                    customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）（二级货主id 必填）
                    pickupCustomerName: this.addBillForm.pickupCustomerName, // （二级货主id 必填）（二级货主id 必填）
                    outBillNo: this.addBillForm.outBillNo, // 客户单号
                    outstockPlateNumber: plateNumber, // （出库车牌号 =人车信息 提货车号逗号拼接 必填）
                    driverName: driverName, // （司机姓名 =人车信息 司机姓名逗号拼接 非必填）
                    carHoldFalg: 0, // 扣车标记 0：不扣，1：扣车 必填）
                    telephone: telephone, // （司机手机 =人车信息 司机电话逗号拼接 非必填）
                    idNumber: idNumber, // （身份证号 =人车信息 司机身份证逗号拼接 非必填）
                    remark: this.addBillForm.remark // （出库提单备注 非必填）
                  },
                  queryList: this.allDataList,
                  pickupCustomerName: this.pickupCustomerName
                }
                // this.addOutStock(n)
                this.recursionCheck(0, n)
              }
            }
            console.log(this.allDataList, 'this.allDataList')
          }
        } else {
          if (n == '1') {
            this.addLoading = false
          } else {
            this.saveLoading = false
          }
        }
      })
    },
    // 调接口
    addOutStock (n) {
      if (n == '1') {
        this.addLoading = true
      } else {
        this.saveLoading = true
      }
      JfaddEmptyOutstockJanFa(this.paramsObject).then(res => {
        if (n == '1') {
          this.addLoading = false
          this.$emit('update:addPlanBillVisible', false)
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          if (this.isShowDYFlag == 2) {
            this.schedulingUpdateWarehouse()
          }
          setTimeout(() => {
            this.$parent.chaxun()
          }, 200)
        } else {
          this.saveLoading = false
          this.$emit('update:addPlanBillVisible', false)
          this.$router.push({
            path: '/zhuangcheDanPrint',
            query: {
              id: res
            }
          })
        }
      }).catch(err => {
        if (n == '1') {
          this.addLoading = false
        } else {
          this.saveLoading = false
        }
        if (err.code == '-200') {
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                pickupCustomerName: this.addBillForm.pickupCustomerName, // （二级货主纳税人识别号  必填）
                organizationId: localStorage.getItem('tenantCode') // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                pickupCustomerName: this.addBillForm.primaryCustopickupCustomerNamemerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: localStorage.getItem('tenantCode'), // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            JfvirtualControlBean(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].surplusControlWeight = isEnableObjB.surplusControlWeight
                  this.allDataList[index].surplusControlNumber = isEnableObjB.surplusControlNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    },
    // 修改获取数据
    getOutstockInfoJanFa () {
      JfgetOutstockInfoJanFa({
        outstockId: this.addBillForm.outstockId
      }).then(res => {

      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    },
    // 递归调用
    recursionCheck (index, n) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.addOutStock(n)
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.surplusControlNumber || item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
              console.log('A')
            }
          } else if (item.controlPiece == '1') { // 控件
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
              console.log('B')
            }
          } else if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
              console.log('C')
            }
          }
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              return
            }
            if (item.sumWeight > item.surplusControlWeight) {
              console.log('999')
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, n)
                console.log('D')
              }).catch(() => { })
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlPiece == '1') {
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlWeight == '1') {
            console.log('控吨')
            if (item.sumWeight > item.surplusControlWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, n)
                console.log('D')
              }).catch(() => { })
            } else {
              this.recursionCheck(index + 1, n)
              console.log('E')
            }
          }
          // else {
          //   this.recursionCheck(index + 1, n)
          //   console.log('F')
          // }
        }
      } else {
        // this.addOutStock(n)
        this.recursionCheck(index + 1, n)
        console.log('G')
      }
      // }
    }
  }
}

</script>

<style>
</style>
